import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import type SessionService from 'teacher-ui-client/services/session'
import { all } from 'rsvp'
import type Teacher from 'teacher-ui-client/models/teacher'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type Student from 'teacher-ui-client/models/student'
import type SchoolClass from 'teacher-ui-client/models/school-class'
import type { NativeArray } from '@ember/array'

export interface MoveStudentsModel {
  students: NativeArray<Student>
  teachers: NativeArray<Teacher>
  teacher: Teacher
  schoolClasses: NativeArray<SchoolClass>
  subscriptionType: SubscriptionType
}

export default class MoveStudentsRoute extends Route {
  @service store!: Store
  @service session!: SessionService

  queryParams = {
    sortCol: {
      replace: true,
    },
    sortDir: {
      replace: true,
    },
    currentPage: {
      replace: true,
    },
    textFilter: {
      replace: true,
    },
    selected: {
      replace: true,
    },
    schoolClassesFilterValue: {
      replace: true,
    },
    teachersFilterValue: {
      replace: true,
    },
    gradesFilterValue: {
      replace: true,
    },
    allocationFilterValue: {
      replace: true,
    },
  }

  buildRouteInfoMetadata() {
    return {
      rolloverLock: {
        subco: {
          lockOtherSubscriptionType: true,
        },
        teacher: {
          lockCurrentSubscriptionType: true,
          lockOtherSubscriptionType: true,
        },
      },
    }
  }

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const studentsPromise = this.store.query<Student>('student', {
      // @ts-expect-error - include types not correct
      include: 'school-classes',
    })

    // load all teachers and school classes.
    const teachersPromise = this.store.query<Teacher>('teacher', {
      // @ts-expect-error - include types not correct
      include: ['school-classes', 'teacher-subscriptions'].join(','),
    })

    const [students, teachers] = await all([studentsPromise, teachersPromise])

    const schoolClasses = this.store.peekAll<SchoolClass>('school-class')

    return {
      students: students.slice(),
      teachers: teachers.slice(),
      teacher: this.session.currentTeacher,
      schoolClasses: schoolClasses.slice(),
      subscriptionType,
    }
  }
}
